"use client"

import { addNewLead } from "@/actions/lead"
import { useState } from "react"

import { useToast } from "@/hooks/use-toast"

import { Button } from "./ui/button"
import { Input } from "./ui/input"

export default function LeadInput({
  boilerplateId,
}: {
  boilerplateId: string
}) {
  const { toast } = useToast()
  const [email, setEmail] = useState("")
  return (
    <div className="flex w-full flex-col gap-3 rounded-md border border-neutral-300 bg-neutral-100 px-5 pb-3 pt-5 shadow-sm">
      <div className="flex flex-col gap-1">
        <p className="text-2xl text-main-black">
          Receive promotional codes for this boilerplate 🥳
        </p>
        <p className="text-neutral-600">
          It&apos;s completely free, and you can be sure that we will never send you
          spams !
        </p>
      </div>
      <div className="flex w-full flex-wrap gap-4">
        <Input
          value={email}
          onChange={(e) => {
            setEmail(e.target.value)
          }}
          type="email"
          className="grow"
          placeholder="Your email"
        />
        <Button
          onClick={() => {
            addNewLead({ email, boilerplateId })
              .then(() => {
                setEmail("")
                toast({
                  title: "Success",
                  description: "Email added successfully!",
                })
              })
              .catch(() => {
                toast({
                  title: "Error",
                  description: "Error while adding email...",
                })
              })
          }}
          variant="outline"
        >
          Get notify
        </Button>
      </div>
    </div>
  )
}
